import { useTheme } from '@mui/material/styles';
import SuspenseLoader from 'components/SuspenseLoader';
import useGoogleAnalytics from 'hooks/useGoogleAnalytics';
import React, { Suspense, lazy } from 'react';
import { useLocation } from 'react-router-dom';
import ScrollToTop from 'scrolltop';
import NavBar from '../NavBar';
import Notifications from '../Notifications';
import { hasFooter, hasNavBar } from './settings';
import './styles.scss';

const Footer = lazy(() => import('components/Footer'));

const Layout: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const location = useLocation();
  const theme = useTheme();
  useGoogleAnalytics();

  const displayFooter = hasFooter(location.pathname);
  const displayNavBar = hasNavBar(location.pathname);

  return (
    <>
      <ScrollToTop />
      {displayNavBar && <NavBar />}

      <div className="layout-body" style={{ backgroundColor: theme.palette.background.default }}>
        {children}
        {displayFooter && (
          <Suspense fallback={<SuspenseLoader />}>
            <Footer />
          </Suspense>
        )}
      </div>
      <Notifications />
    </>
  );
};

export default Layout;
